import { a as getUserListById, i as getUserListById1, n as getUsers, o as getUserInfo, r as getUserListByIdFromPost, s as getCurrentUserInfo, t as getUsersPaginated } from "./getUsersPaginated.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/auth/user/hooks/useGetCurrentUserInfo.ts
const getCurrentUserInfoQueryKey = () => [{ url: "/auth/proxy/user/current" }];
function getCurrentUserInfoQueryOptions(config = {}) {
	const queryKey = getCurrentUserInfoQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getCurrentUserInfo({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить информацию о текущем пользователе.
* {@link /auth/proxy/user/current}
*/
function useGetCurrentUserInfo(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getCurrentUserInfoQueryKey();
	const queryResult = useQuery({
		...getCurrentUserInfoQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/user/hooks/useGetUserInfo.ts
const getUserInfoQueryKey = ({ path }) => [{
	url: "/auth/proxy/user/:userId",
	params: path
}];
function getUserInfoQueryOptions({ path }, config = {}) {
	const queryKey = getUserInfoQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUserInfo({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить информацию о пользователе по его id.
* {@link /auth/proxy/user/:userId}
*/
function useGetUserInfo({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getUserInfoQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUserInfoQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/user/hooks/useGetUserListById.ts
const getUserListByIdQueryKey = ({ query }) => [{ url: "/v2/auth/proxy/user/list" }, ...query ? [query] : []];
function getUserListByIdQueryOptions({ query }, config = {}) {
	const queryKey = getUserListByIdQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUserListById({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить список пользователей по их id.
* {@link /v2/auth/proxy/user/list}
*/
function useGetUserListById({ query }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getUserListByIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUserListByIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/user/hooks/useGetUserListById1.ts
const getUserListById1QueryKey = ({ query }) => [{ url: "/auth/proxy/user/list" }, ...query ? [query] : []];
function getUserListById1QueryOptions({ query }, config = {}) {
	const queryKey = getUserListById1QueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUserListById1({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить список пользователей с id, которые были переданы в теле запроса.
* {@link /auth/proxy/user/list}
*/
function useGetUserListById1({ query }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getUserListById1QueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUserListById1QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/user/hooks/useGetUserListByIdFromPost.ts
const getUserListByIdFromPostMutationKey = () => [{ url: "/v2/auth/proxy/user/list" }];
function getUserListByIdFromPostMutationOptions(config = {}) {
	const mutationKey = getUserListByIdFromPostMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await getUserListByIdFromPost({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить список пользователей по их id.
* {@link /v2/auth/proxy/user/list}
*/
function useGetUserListByIdFromPost(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? getUserListByIdFromPostMutationKey();
	const baseOptions = getUserListByIdFromPostMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/auth/user/hooks/useGetUsers.ts
const getUsersQueryKey = () => [{ url: "/auth/proxy/user" }];
function getUsersQueryOptions(config = {}) {
	const queryKey = getUsersQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUsers({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить список пользователей.
* {@link /auth/proxy/user}
*/
function useGetUsers(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getUsersQueryKey();
	const queryResult = useQuery({
		...getUsersQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/auth/user/hooks/useGetUsersPaginated.ts
const getUsersPaginatedQueryKey = ({ query } = {}) => [{ url: "/auth/proxy/user/paginated" }, ...query ? [query] : []];
function getUsersPaginatedQueryOptions({ query } = {}, config = {}) {
	const queryKey = getUsersPaginatedQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getUsersPaginated({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Поиск по Ф, О или И и пагинация пользователей.
* {@link /auth/proxy/user/paginated}
*/
function useGetUsersPaginated({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getUsersPaginatedQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getUsersPaginatedQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
export { getUserInfoQueryOptions as _, getUsersQueryOptions as a, getCurrentUserInfoQueryOptions as b, getUserListByIdFromPostMutationOptions as c, getUserListById1QueryOptions as d, useGetUserListById1 as f, getUserInfoQueryKey as g, useGetUserListById as h, getUsersQueryKey as i, useGetUserListByIdFromPost as l, getUserListByIdQueryOptions as m, getUsersPaginatedQueryOptions as n, useGetUsers as o, getUserListByIdQueryKey as p, useGetUsersPaginated as r, getUserListByIdFromPostMutationKey as s, getUsersPaginatedQueryKey as t, getUserListById1QueryKey as u, useGetUserInfo as v, useGetCurrentUserInfo as x, getCurrentUserInfoQueryKey as y };

//# sourceMappingURL=useGetUsersPaginated.js.map